import script from "./BreadcrumbView.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbView.vue?vue&type=script&setup=true&lang=js"

import "./BreadcrumbView.vue?vue&type=style&index=0&id=39c9cf2a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c9cf2a"]])

export default __exports__